<template>
    <div class="menu-modal-container">
        <div class="menu-modal-content menu-modal-content-background-default">
            <div class="menu-modal-content-header">
                UMA
            </div>
            <div class="menu-modal-content-body">
                <div class="menu-modal-content-title">
                    <div class="menu-modal-icon menu-modal-icon-success">
                        <span class="mdi mdi-help"></span>
                    </div>
                    <div class="menu-modal-content-title-text">
                        <p>{{ contentMessage }}</p>
                    </div>
                </div>
                <div class="menu-btn-modal-container">
                    <button class="menu-modal-btn menu-modal-confirm-btn" @click="methodForProp">Aceptar</button>
                    <button class="menu-modal-btn menu-modal-cancel-btn" @click="closeModal">Cancelar</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ActionConfirmModal",
    props: {
        methodForProp: {
            type: Function,
            required: true,
        },
        closeModal: {
            type: Function,
            required: true,
        },
        contentMessage: {
            type: String,
            required: true,
        }
    },
};
</script>

<style scoped>

</style>